<template>
  <div class="PipelineSummary">
    <science-sidebar></science-sidebar>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Science/pipeline_summary.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <div class="text-center" id="welcome">
    </div>
    <analysis-sidebar></analysis-sidebar>
    <h4>Pipeline Summary</h4>
    <b-container fluid>
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-row v-if="items.length != 0">
        <b-table show-empty
               :items="items"
               :fields="fields"
               :small="smallTable"
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               @filtered="onFiltered"
        >
          <template v-slot:cell(source)="row">{{row.value.first}} {{row.value.last}}</template>
          <template v-slot:cell(isActive)="row">{{row.value?'Yes :)':'No :('}}</template>
          <template v-slot:cell(row-details)="row">
            <b-card>
              <ul>
                <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
              </ul>
            </b-card>
          </template>
        </b-table>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <p>Fetching Data...</p>
        </b-col>
      </b-row>
      <div>
        <h4 id='num-candidates'></h4>
        <h6 id='num-intensity-fitburst'></h6>
        <h6 id='num-baseband'></h6>
        <h6 id='num-intensity-dm-pipeline'></h6>
        <h6 id='num-intensity-localization'></h6>
        <h6 id='num-header-localization'></h6>
        <h6 id='num-intensity-calibration'></h6>
      </div>
    </b-container>
  </div>
</template>

<script>
import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
import scienceSidebar from './scienceSidebar'
// import VuePlotly from '@statnett/vue-plotly'
// import VueCsvDownloader from 'vue-csv-downloader'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
// baseUrl = 'http://localhost:8001/'
var fields = [
  {key: 'event_id', label: 'Event No', sortable: true, 'class': 'text-center'},
  {key: 'datetime', label: 'Datetime (UTC)', sortable: true, 'class': 'text-center'},
  {key: 'header-localization', label: 'header Localization', sortable: true, 'class': 'text-center'},
  {key: 'intensity-dm-pipeline', label: 'DM pipeline', sortable: true, 'class': 'text-center'},
  {key: 'intensity-fitburst', label: 'Fitburst', sortable: true, 'class': 'text-center'},
  {key: 'intensity-calibration', label: 'Flux/Fluence', sortable: true, 'class': 'text-center'},
  {key: 'intensity-localization', label: 'intensity Localization', sortable: true, 'class': 'text-center'},
  {key: 'baseband', label: 'Baseband', sortable: true, 'class': 'text-center'}
]
export default {
  components: {
    // VueCsvDownloader,
    'science-sidebar': scienceSidebar
  },
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      items: [],
      fields: [],
      fieldtitle: 'User Ratings',
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 10,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: null,
      plot: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      modalInfo: { title: '', content: '' }
    }
  },
  mounted () {
    if (this.user) {
      document.getElementById('welcome').innerHTML = 'Welcome @' + localStorage.username
      var url = 'https://frb.chimenet.ca/frb-master/v1/candidates?full_candidate=True'
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.fields = fields
          this.parseResponse(response.body)
        }, response => {
        })
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.showfields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },
    nameState () {
      return this.knownsource.length > 7
    },
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    needcheckbox (value) {
      if (value === '') {
        return false
      }
      return true
    },
    fetchEvents () {
      var eventUrl = 'https://frb.chimenet.ca/frb-master/v1/events'
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(eventUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(eventresponse => {
          this.parseEvents(eventresponse.body)
        }, eventeresponse => {
        })
    },
    parseEvents (r) {
      var basebandCount = 0
      var fitburstCount = 0
      var localizationCount = 0
      var hdrLocalizationCount = 0
      var dmPipelineCount = 0
      var intensityCalibrationCount = 0
      for (var i = 0; i < r.length; i++) {
        var value = {}
        value['event_id'] = r[i]['id']
        value['baseband'] = 0
        value['intensity-localization'] = 0
        value['header-localization'] = 0
        value['intensity-dm-pipeline'] = 0
        value['intensity-calibration'] = 0
        value['intensity-fitburst'] = 0
        var lockedPipelines = []
        if (Object.keys(r[i]).includes('locked')) {
          lockedPipelines = r[i].locked
        }
        if (Object.keys(lockedPipelines).includes('baseband')) {
          value['baseband'] = 1
          basebandCount = basebandCount + 1
        }
        if (Object.keys(lockedPipelines).includes('intensity-fitburst')) {
          value['intensity-fitburst'] = 1
          fitburstCount = fitburstCount + 1
        }
        if (Object.keys(lockedPipelines).includes('intensity-dm-pipeline')) {
          value['intensity-dm-pipeline'] = 1
          dmPipelineCount = dmPipelineCount + 1
        }
        if (Object.keys(lockedPipelines).includes('intensity-localization')) {
          value['intensity-localization'] = 1
          localizationCount = localizationCount + 1
        }
        if (Object.keys(lockedPipelines).includes('header-localization')) {
          value['header-localization'] = 1
          hdrLocalizationCount = hdrLocalizationCount + 1
        }
        if (Object.keys(lockedPipelines).includes('intensity-calibration')) {
          value['intensity-calibration'] = 1
          intensityCalibrationCount = intensityCalibrationCount + 1
        }
        for (var j = 0; j < this.items.length; j++) {
          if (value['event_id'] === this.items[j]['event_id']) {
            this.items[j]['baseband'] = value['baseband']
            this.items[j]['intensity-fitburst'] = value['intensity-fitburst']
            this.items[j]['intensity-dm-pipeline'] = value['intensity-dm-pipeline']
            this.items[j]['intensity-localization'] = value['intensity-localization']
            this.items[j]['header-localization'] = value['header-localization']
            this.items[j]['intensity-calibration'] = value['intensity-calibration']
            break
          }
        }
      }
      document.getElementById('num-baseband').innerHTML = 'Validated Baseband Results: ' + basebandCount
      document.getElementById('num-intensity-fitburst').innerHTML = 'Validated Fitburst Results: ' + fitburstCount
      document.getElementById('num-intensity-dm-pipeline').innerHTML = 'Validated Intensity DM Pipeline Results: ' + dmPipelineCount
      document.getElementById('num-intensity-localization').innerHTML = 'Validated Intensity Localization Results: ' + localizationCount
      document.getElementById('num-header-localization').innerHTML = 'Validated Header Localization Results: ' + hdrLocalizationCount
      document.getElementById('num-intensity-calibration').innerHTML = 'Validated Flux/Fluence Measurements: ' + intensityCalibrationCount
    },
    parseResponse (events) {
      var candidateCount = events.length
      this.items = []
      var candEvents = []
      for (var i = 0; i < events.length; i++) {
        var item = {}
        if (events[i]['events'].length > 0) {
          item['event_id'] = events[i]['events'][0]['id']
          item['datetime'] = events[i]['events'][0]['measured_parameters'][0]['datetime'].slice(0, 23)
          item['_rowVariant'] = 'danger'
          item['baseband'] = null
          item['intensity-fitburst'] = null
          item['intensity-localization'] = null
          item['header-localization'] = null
          item['intensity-dm-pipeline'] = null
          item['intensity-calibration'] = null
          this.items.push(item)
          for (var j = 0; j < events[i]['events'].length; j++) {
            candEvents.push(events[i]['events'][j])
          }
        }
      }
      this.parseEvents(candEvents)
      document.getElementById('num-candidates').innerHTML = 'Total Candidates: ' + candidateCount
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Science/pipeline_summary.vue